import React from 'react';

const LogoutPage = () => {
  return <div>I am LogoutPage</div>;
};

export default LogoutPage;
